module.exports = __webpack_public_path__ + "img/projecto-2.f58017ad.png";